import { render, staticRenderFns } from "./Universidades.vue?vue&type=template&id=5cb19b7c"
import script from "./Universidades.vue?vue&type=script&lang=js"
export * from "./Universidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports